<script>
import constants from '../../common/constants'
import store from '../../common/store'

export default {
  props:{
    page: {
      type: Object,
      default: () => ({
        id: '',
        title: '',
        Url: '',
        eventImageUrl: '',
        eventHomeUrl: '',
        eventName: '',
        donateUrl: '',
        pageType: '',
        raised: '',
        secondaryBgColor: '',
        imageUrl: '',
      }),
    },
    hideJoinTeam: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      store,
    }
  },

  computed: {
    teamUrl() {            
      return this.page.joinTeamUrl ?? `${this.page.eventHomeUrl}/pages/create?tid=${this.page.id}`
    },
    isTeam() {
      return this.page.pageType === constants.FUNDRAISING_PAGE_TEAM_TYPE_ID
    },
    raised() {
      return parseFloat(this.page.raised).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    itemClass() {
      return this.hideJoinTeam? 'search-item-wrap-no-join-team' : ''
    },
    getCurrencySymbol() {
      return this.store.state.currencySymbol
    },
  },
  
  methods: {
    onItemClicked(page) {
      window.location = page.pageUrl
    },
  },
}
</script>
